import type { TradeInAemDetailFormItem } from "../../utils/types";
import {
    type TradeInAemVehicleDetailsActions,
    TRADE_IN_AEM_INIT_FORM_ITEMS,
    TRADE_IN_AEM_SET_FORM_ITEM_VALUE,
} from "../actions/TradeInAemVehicleDetailsActions";

export type TradeInAemVehicleDetailsReducerType = {
    formItems: { [formItemKey: string]: TradeInAemDetailFormItem };
};

const initialState: TradeInAemVehicleDetailsReducerType = {
    formItems: {},
};

export const TradeInAemVehicleDetailsReducer = (
    state: TradeInAemVehicleDetailsReducerType = initialState,
    action: TradeInAemVehicleDetailsActions,
): TradeInAemVehicleDetailsReducerType => {
    switch (action.type) {
        case TRADE_IN_AEM_INIT_FORM_ITEMS:
            return { ...state, formItems: action.formItems };

        case TRADE_IN_AEM_SET_FORM_ITEM_VALUE: {
            const { formItemKey, formItemValue } = action;

            const newFormItem = { ...state.formItems[formItemKey], value: formItemValue };
            return { ...state, formItems: { ...state.formItems, [formItemKey]: newFormItem } };
        }

        default:
            return state;
    }
};
